module.exports = __webpack_public_path__ + "static/img/logo_micro.aa27a7b6.svg";